module.exports = __webpack_public_path__ + "img/contato.ee9531cc.png";